import { AppConfig } from 'src/app/configs/app-config';
import { LocalStorageService } from "src/app/core/services/local-storage/local-storage.service";
import { CivilStatus } from '../models/enum/civil-status.enum';

class ReglasACM {
  public constructor(
    private edadMin: number,
    private edadMax: number,
    private estadosCivil?: string[]) {
      this.edadMin = edadMin;
      this.edadMax = edadMax;
      this.estadosCivil = estadosCivil || [];
  }

  public esEdadPermitida(edad: number): boolean {
    return (edad >= this.edadMin && edad <= this.edadMax);
  }

  public esEstadoCivilValido(estadoCivilAfiliado: string) {
    if (this.estadosCivil.length == 0)
      return true;

    return this.estadosCivil.includes(estadoCivilAfiliado);
  }
}

export class ACMValidator {
  private static categoriasPermitidas = ["A", "B"];
  private static horaMin = 96;
  private static reglasPadres = new ReglasACM(60, 120);
  private static reglasHijosHermanos =  new ReglasACM(0, 18);
  private static reglasHijastro = new ReglasACM(0, 18, [CivilStatus.FREE_UNION.codigo, CivilStatus.MARRIED.codigo]);
  private static reglasACM = {
      Hijo: ACMValidator.reglasHijosHermanos,
      Hermano: ACMValidator.reglasHijosHermanos,
      Hijastro: ACMValidator.reglasHijastro,
      Padre: ACMValidator.reglasPadres,
      Madre: ACMValidator.reglasPadres
  }

  public static hasRequest(numberDoc: string, data: Array<any>) {
    return data.some(r => r == numberDoc);
  }

  public static esAfiliacionVigente(estadoAfiliacion: string): Boolean {
    return (estadoAfiliacion == 'VIGEN');
  }

  public static esCategoriaPermitida(categoriaAfiliado: string): Boolean {
    return this.categoriasPermitidas.includes(categoriaAfiliado);
  }

  public static esAcreditacionCuotaMonetariaValida(edadBeneficiario: number, parentescoBeneficiario: string, estadoCivilAfiliado: string, horasTrabajadas: number,): Boolean {
    const reglasParentesco: ReglasACM = this.reglasACM[parentescoBeneficiario];

    if (!reglasParentesco) {
      return false;
    }

    return (reglasParentesco.esEstadoCivilValido(estadoCivilAfiliado) &&
            reglasParentesco.esEdadPermitida(edadBeneficiario) &&
            this.esHorasPermitida(horasTrabajadas));
  }

  public static esHorasPermitida(horas: number): boolean {
    return (horas*30 >= this.horaMin);
  }

  public static obtenerCategoriaPorSalario(salario: number, localStorageService: LocalStorageService): boolean {
      let categoria: boolean;
      let SalarioDefault: number = AppConfig.salarioMinimo();

      switch(true) {
        case salario <= SalarioDefault*2:
          categoria = true;
          break;
        case salario <= SalarioDefault*4:
          categoria = true;
          break;
        case salario > SalarioDefault*4:
          categoria = false;
          break;
        case salario > SalarioDefault*6:
          categoria = false;
          break;
        default:
          categoria = false;
      }
      return categoria;
    }

    public static esSalarioConConyugePermitido(salarioConyuge: number, SalarioEmpleado: number,localStorageService: LocalStorageService): boolean {
      let salario = salarioConyuge + SalarioEmpleado;
      return this.obtenerCategoriaPorSalario(salario, localStorageService);
    }
}
